@use "../../config/defaults.module.scss" as defaults;

.logo {
	img {
		@apply
		yst-w-32
		lg:yst-w-44;
	}
}
